<template>
  <div class="row">
    <div class="col-12 pb-4 pt-1">
      <div id="datatable1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row">
          <div class="col-sm-12 col-md-6"></div>
          <div class="col-sm-12 col-md-6"></div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <table id="datatable1" class="display dataTable no-footer" style="width: 100%;" role="grid" aria-describedby="datatable1_info">
              <thead>
                  <tr role="row">
                    <th :class="OrderByName" @click="orderBy(1)">{{ $t('label.nome') }}</th>
                    <th :class="OrderByEmail" @click="orderBy(2)">{{ $t('label.email') }}</th>
                    <th :class="OrderByPhone" @click="orderBy(3)">{{ $t('label.telefone') }}</th>
                    <th class="align-items-end">{{ $t('label.acoes') }}</th>
                  </tr>
              </thead>
              <tbody>
                <tr v-if="$store.state.countList === 0"><td colspan="4" class="text-center">{{ $t('message.noRecords') }}</td></tr>
                <tr v-else v-for="item in items" :key="item.id_user" role="row" class="odd">
                  <td>{{item.name}}</td>
                  <td>{{item.email}}</td>
                  <td>{{item.phone}}</td>
                  <td>
                    <ul class="list-group list-group-horizontal list-acoes ">
                      <li class="list-acoes-edit">
                        <a @click="action(this.constants.actionEdit, item)"><i class="material-icons">edit</i></a>
                      </li>
                      <li class="list-acoes-delete">
                        <a @click="action(this.constants.actionDelete, item)" v-if="$store.state.user && $store.state.user.sysUser.user_level === 1"><i class="material-icons">delete</i></a>
                      </li>
                      <li v-if="item.user_level === 3">
                        <a @click="action(this.constants.actionEdit, item)"><i class="material-icons">smartphone</i></a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <AppTablePagination @searchTable="search()" :count="count"/>
      </div>
    </div>
  </div>
</template>

<script>
import AppTablePagination from '../../components/AppTablePagination.vue'
import axios from 'axios'
export default {
  name: 'UsuariosTableView',
  components: { AppTablePagination },
  props: {
    items: Array,
    count: Number,
    withOrderBy: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    dataOrderBy: {}
  }),
  computed: {
    OrderByName: function () {
      if (this.$store.state.dataOrderBy.OrderByNameAcs) {
        return 'sorting_asc'
      } else if (this.$store.state.dataOrderBy.OrderByNameDesc) {
        return 'sorting_desc'
      } else {
        return 'sorting'
      }
    },
    OrderByEmail: function () {
      if (this.$store.state.dataOrderBy.OrderByEmailAcs) {
        return 'sorting_asc'
      } else if (this.$store.state.dataOrderBy.OrderByEmailDesc) {
        return 'sorting_desc'
      } else {
        return 'sorting'
      }
    },
    OrderByPhone: function () {
      if (this.$store.state.dataOrderBy.OrderByPhoneAcs) {
        return 'sorting_asc'
      } else if (this.$store.state.dataOrderBy.OrderByPhoneDesc) {
        return 'sorting_desc'
      } else {
        return 'sorting'
      }
    }
  },
  methods: {
    action: function (action, item) {
      if (action === this.constants.actionDelete) {
        if (confirm(this.$t('message.confirmDel'))) {
          this.delete(item)
        }
      } else {
        this.$router.push({ name: 'usuariosForm', params: { id: item.id_user } })
      }
    },
    delete: function (item) {
      axios.delete(`/user/${item.id_user}`)
        .then(() => {
          this.$toast.success(this.constants.success)
          this.search()
        })
    },
    search: function () {
      this.$emit('search')
    },
    orderBy: function (num) {
      if (num === 1) {
        if (this.$store.state.dataOrderBy.OrderByNameAcs) {
          this.$store.state.dataOrderBy.OrderByNameDesc = true
        } else {
          this.$store.state.dataOrderBy.OrderByNameDesc = false
        }
        this.$store.state.dataOrderBy.OrderByNameAcs = !this.$store.state.dataOrderBy.OrderByNameAcs
      }
      if (num === 2) {
        if (this.$store.state.dataOrderBy.OrderByEmailAcs) {
          this.$store.state.dataOrderBy.OrderByEmailDesc = true
        } else {
          this.$store.state.dataOrderBy.OrderByEmailDesc = false
        }
        this.$store.state.dataOrderBy.OrderByEmailAcs = !this.$store.state.dataOrderBy.OrderByEmailAcs
      }
      if (num === 3) {
        if (this.$store.state.dataOrderBy.OrderByPhoneAcs) {
          this.$store.state.dataOrderBy.OrderByPhoneDesc = true
        } else {
          this.$store.state.dataOrderBy.OrderByPhoneDesc = false
        }
        this.$store.state.dataOrderBy.OrderByPhoneAcs = !this.$store.state.dataOrderBy.OrderByPhoneAcs
      }
      this.$emit('orderBy', this.$store.state.dataOrderBy)
    }
  }
}
</script>
